import * as Sentry from "@sentry/react";

export const handleError = (error) => {
    try {
        if (!Sentry.isInitialized()) {
            return
        }
        Sentry.captureException(error)
    } catch (e) {
        console.error('Failed report error to Sentry')
        console.error(e)
    }

}
